import { render, staticRenderFns } from "./Mycode.vue?vue&type=template&id=0cb0748b"
import script from "./Mycode.vue?vue&type=script&lang=js"
export * from "./Mycode.vue?vue&type=script&lang=js"
import style0 from "./Mycode.vue?vue&type=style&index=0&id=0cb0748b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports